import React from 'react';

import ArrowRightIcon from '@atlaskit/icon/glyph/arrow-right';

import IssueStatusesSelect from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/IssueStatusesSelect';
import RowLayout3Components from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/RowLayout3Components';
import SelectActions from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/SelectActions';
import { useApplicableActions } from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/SelectActions/actions';
import AutoscalableInputsArray from 'src/views/components/Form/AutoscalableInputsArray';
import Field from 'src/views/components/Form/Field';
import FieldLabel from 'src/views/components/Form/FieldLabel';

import CheckboxedSection from '../components/CheckboxedSection';

const InfoMessage = () => {
  return (
    <ul>
      <li>Each Jira status can trigger multiple PagerDuty actions</li>
      <li>Rules will only be applied when there is a change in status</li>
    </ul>
  );
};

const SingleStatusMapping = ({ name, values = {}, touched = {}, errors = {}, onChange, onBlur }) => {
  const actions = useApplicableActions({ incidentUpdateActions: true });

  return (
    <RowLayout3Components>
      <Field errorMessage={touched.jira_statuses && errors.jira_statuses}>
        <IssueStatusesSelect
          name={`${name}.jira_statuses`}
          value={values.jira_statuses}
          onChange={onChange}
          onBlur={onBlur}
          isMulti
        />
      </Field>
      <ArrowRightIcon size="xlarge"/>
      <SelectActions
        actions={actions}
        name={name}
        values={values}
        touched={touched}
        errors={errors}
        onChange={onChange}
        onBlur={onBlur}
      />
    </RowLayout3Components>
  );
};


const isItemEmpty = (value) => {
  if (!value || typeof value !== 'object') return true;
  const { jira_statuses, actions } = value;
  if (Array.isArray(jira_statuses) && jira_statuses.length) return false;
  if (Array.isArray(actions) && actions.length) return false;
  return true;
};
const newItemValue = { jira_statuses: [], actions: [] };


const ReactOnJiraStatusChange = ({ name, values = {}, touched = {}, errors = {}, onChange, onBlur }) => {
  return (
    <CheckboxedSection
      name={`${name}.react_on_issue_status_change`}
      value={values.react_on_issue_status_change}
      onChange={onChange}
      onBlur={onBlur}
      label="Automatically update PagerDuty incident"
      helpMessage={<InfoMessage/>}
    >

      <RowLayout3Components>
        <FieldLabel>When Issue status changes to:</FieldLabel>
        <div/>
        <FieldLabel>Actions:</FieldLabel>
      </RowLayout3Components>

      <AutoscalableInputsArray
        name={`${name}.react_on_issue_status_change_config`}
        values={values.react_on_issue_status_change_config}
        touched={touched.react_on_issue_status_change_config}
        errors={errors.react_on_issue_status_change_config}
        onChange={onChange}
        onBlur={onBlur}
        ItemComponent={SingleStatusMapping}
        isItemEmpty={isItemEmpty}
        newItemValue={newItemValue}
      />
    </CheckboxedSection>
  );
};

export default ReactOnJiraStatusChange;
